<section id="team-management-container" #teammanagercontainer cdk-scrollable>
<app-loading size="0.5" class="loading-spinner" *ngIf="isLoading$ | async; else wrapper" color="var(--primary-sec-color)"></app-loading>
  
<ng-template #wrapper>
  <section id='header'>
    <div class='title'>
      <div class='main'>{{'teamManagement.teamManagement'| translate}}</div>
    </div>

    <div class='actions'>
      <div class='action' (click)="onAddNewTeam()">{{'teamManagement.addNewTeam'| translate}} <span class="plus">+</span></div>
    </div>
  </section>

  <section id='body' cdkDropListGroup>
    <section id='unassigned'>
      <section class='advisors'>
        <div class='title'>{{'teamManagement.unassignedServiceAdvisor'| translate}} <span class="count">({{unassignedServiceAdvisorsCount$ | async}})</span>
        </div>
        <multi-drag-drop
          class='employees'
          emptyText="{{'otherTexts.thereAreNoUnassignedAdvisors'| translate}}"
          [items]="unassignedServiceAdvisors$ | async"
          (itemsAdded)="itemsAdded($event, 1)"
          (itemsUpdated)="itemsUpdated($event, 1)"
          (cdkDragStarted)="cdkDragStarted($event)"
          
        >
          <ng-template let-item>
            <app-employee [employee]="item"></app-employee>
          </ng-template>
        </multi-drag-drop>

      </section>
      <section class='technicians'>
        <div class='title'>{{'teamManagement.unassignedTechnicians'| translate}} <span class="count">({{unassignedServiceTechniciansCount$ | async}})</span>
        </div>
        <multi-drag-drop
          class='employees'
          emptyText="{{'otherTexts.thereAreNoUnassignedTechnicians'| translate}}"
          [items]="unassignedServiceTechnicians$ | async"
          (itemsAdded)="itemsAdded($event, 2)"
          (itemsUpdated)="itemsUpdated($event, 2)"
          (cdkDragStarted)="cdkDragStarted($event)"
        >
          <ng-template let-item>
            <app-employee [employee]="item"></app-employee>
          </ng-template>
        </multi-drag-drop>

      </section>
    </section>

    <section id='teams-container'>
      <div class='title'>{{'scheduleRotation.teams'| translate}} <span class="count">({{teamsCount$ | async}})</span></div>

      <div class='teams'>
        <app-team-card class="team"
                       *ngFor="let team of teams$ | async | orderBy:'name'"
                       [team]="team"
                       (cdkDragStarted)="cdkDragStarted($event)"
                       >
        </app-team-card>
      </div>
    </section>
  </section>
</ng-template>
</section>
